import {MolecularGraph} from "../../graph/MolecularGraph"
import {rxhExtractor} from "./rxhExtractor";
import {Features} from "../../feature";

export const thiolExtractor = {
    extract: (graph: MolecularGraph) => rxhExtractor.extract("S", Features.thiol, graph)
}
